import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import {
  getAnnouncements,
  dismissAnnouncement,
  type Announcement,
} from "@/lib/api/announcements";

const ANNOUNCEMENTS_KEY = ["announcements"];

export function useAnnouncements() {
  return useQuery({
    queryKey: ANNOUNCEMENTS_KEY,
    queryFn: async () => {
      const result = await getAnnouncements();
      return result.data;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useDismissAnnouncement() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => dismissAnnouncement(id),
    onMutate: async (id) => {
      await queryClient.cancelQueries({ queryKey: ANNOUNCEMENTS_KEY });

      const previous =
        queryClient.getQueryData<Announcement[]>(ANNOUNCEMENTS_KEY);

      queryClient.setQueryData<Announcement[]>(ANNOUNCEMENTS_KEY, (old) =>
        old ? old.filter((a) => a.id !== id) : []
      );

      return { previous };
    },
    onError: (_err, _id, context) => {
      if (context?.previous) {
        queryClient.setQueryData(ANNOUNCEMENTS_KEY, context.previous);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ANNOUNCEMENTS_KEY });
    },
  });
}
